module.exports = __webpack_public_path__ + "static/media/DNIF-logo-dark.62070ce9.svg";